(function () {
  'use strict';
  const dialog = document.getElementById('mel-product-lightbox');
  const data = document.getElementById('mel-product-photo-data');
  const main = document.querySelector('main');
  if (!dialog || !data || !main || typeof dialog.showModal !== 'function') return;
  const fullImage = dialog.querySelector('img');
  const closeButton = dialog.querySelector('button');
  const originals = new Map();
  const key = (src) => { try { return new URL(src, location.href).pathname; } catch (_) { return ''; } };
  try { JSON.parse(data.textContent).forEach((src) => originals.set(key(src), src)); } catch (_) { return; }
  let opener = null, oldOverflow = '';
  function eligible(img) {
    if (img.dataset.melProductPhoto === 'true') return true;
    if (img.closest('.thumbnail, .thumbnail-list, [data-thumbnail], .product-card, .card-wrapper')) return false;
    return originals.has(key(img.currentSrc || img.dataset.src || img.src));
  }
  function decorate() {
    main.querySelectorAll('h2, h3').forEach((heading) => {
      if (heading.textContent.trim().toLowerCase() === 'photos') {
        heading.parentElement.querySelectorAll('img').forEach((img) => { img.dataset.melProductPhoto = 'true'; });
      }
    });
    main.querySelectorAll('img').forEach((img) => {
      if (!eligible(img)) return;
      img.dataset.melProductPhoto = 'true';
      if (img.getAttribute('role') !== 'button') img.setAttribute('role', 'button');
      if (img.tabIndex !== 0) img.tabIndex = 0;
      const label = 'Enlarge ' + (img.alt || 'product photo');
      if (img.getAttribute('aria-label') !== label) img.setAttribute('aria-label', label);
      img.setAttribute('aria-haspopup', 'dialog');
    });
  }
  function open(img) {
    if (dialog.open) return;
    const src = img.currentSrc || img.dataset.src || img.src;
    let large = originals.get(key(src));
    if (!large) {
      const url = new URL(src, location.href);
      if (url.hostname.endsWith('shopify.com') || url.hostname === location.hostname) {
        url.searchParams.delete('width'); url.searchParams.delete('height');
      }
      large = url.href;
    }
    fullImage.src = large;
    fullImage.alt = img.alt || 'Enlarged product photo';
    opener = img;
    oldOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    dialog.showModal();
    closeButton.focus();
  }
  main.addEventListener('click', (event) => {
    const img = event.target.closest('img');
    if (!img || !eligible(img)) return;
    event.preventDefault(); event.stopImmediatePropagation(); open(img);
  }, true);
  main.addEventListener('keydown', (event) => {
    if ((event.key === 'Enter' || event.key === ' ') && event.target.matches('img') && eligible(event.target)) {
      event.preventDefault(); event.stopImmediatePropagation(); open(event.target);
    }
  }, true);
  closeButton.addEventListener('click', () => dialog.close());
  dialog.addEventListener('click', (event) => { if (event.target === dialog) dialog.close(); });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = oldOverflow;
    fullImage.removeAttribute('src');
    if (opener && opener.isConnected) opener.focus({ preventScroll: true });
  });
  decorate();
  new MutationObserver(decorate).observe(main, { childList: true, subtree: true });
})();
